<template>
    <div class="w-full bg-view-sea-blue py-16 items-center rounded-sm gap-16">
        <div class="container flex flex-col md:grid md:grid-cols-12 items-center justify-center gap-16">
            <h1 :id="headingId" class="view-h1 col-span-full md:col-start-2 md:col-end-5 text-center md:text-left">{{textUtils.get_hyphenated_content(title)}}</h1>
            <ResponsiveImage
                v-if="profilePicture"
                :image-id="profilePicture"
                sizes="(min-width: 1024px) 10.5rem, (min-width: 768px) 7.5rem, 13rem"
                class="rounded-full w-52 aspect-square md:w-30 h-auto lg:w-42 max-w-full shrink-0 justify-self-center object-center object-cover col-span-full md:col-start-6 md:col-end-8 self-center"
            />
            <div class="flex flex-col gap-16 md:gap-8 items-center col-span-full md:col-start-8 md:col-end-12">
                <div class="text-center md:text-left max-w-2xl">
                    <RenderedHTML :value="text" />
                </div>
                <div class="border py-2 px-4 rounded-full flex items-center justify-center self-center md:self-start">
                    <NuxtLink :to="localePath('/contact')">
                            {{ t('contact-us') }}
                    </NuxtLink>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>

import RenderedHTML from "~/components/view/RenderedHTML.vue"
import type { LocalizedText } from "#layers/cms/shared/types/bucketData"

const mainStore = useMainStore()
const localePath = useLocalePath()
const { t, locale } = useI18n({useScope: 'local'})
const textUtils = useTextUtils()

const { title, headingId } = defineProps({
    title: String,
    profilePicture: String,
    text: Object as PropType<LocalizedText>,
    headingId: String
})

</script>

<i18n lang="yaml">
en:
    contact-us: Contact us
nl:
    contact-us: Neem contact met ons op
</i18n>
